import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.03 5.676a.667.667 0 0 1 .768.546l.986 5.792c.086.507.14.82.212 1.046.064.203.119.26.163.294.052.04.255.132.663.206.375.067.835.105 1.305.107a7.7 7.7 0 0 0 1.311-.098c.41-.072.621-.166.685-.215.044-.034.099-.09.163-.294.071-.226.126-.539.212-1.045l.986-5.793a.667.667 0 0 1 1.314.223l-.985 5.794-.008.045c-.077.451-.146.854-.248 1.177-.112.357-.286.69-.617.947-.336.26-.827.396-1.271.474A9 9 0 0 1 8.12 15a9 9 0 0 1-1.536-.128c-.434-.079-.918-.212-1.244-.465-.33-.256-.504-.588-.617-.946-.102-.325-.171-.73-.248-1.185l-.007-.038-.985-5.793a.667.667 0 0 1 .545-.769",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.174 3.666a3.27 3.27 0 0 0-3.038 2.058l-.343.857a.667.667 0 0 1-1.238-.495l.343-.857a4.605 4.605 0 0 1 8.553 0l.342.857a.667.667 0 1 1-1.238.495l-.342-.857a3.27 3.27 0 0 0-3.039-2.058",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.84 6.333c0-.368.3-.666.668-.666h9.333a.667.667 0 1 1 0 1.333H3.508a.667.667 0 0 1-.667-.667",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.172 1.088c.32.183.43.59.248.91L8.753 6.664a.667.667 0 0 1-1.158-.661l2.667-4.667c.183-.32.59-.43.91-.248M9.83 9.667c-.507-.009-.912.177-1.166.452-.534.578-1.312.893-2.156.881-.844.011-1.623-.303-2.157-.88a.667.667 0 1 1 .98-.906c.254.276.66.461 1.165.453h.023c.506.008.911-.177 1.166-.453.534-.578 1.312-.892 2.156-.88.844-.012 1.622.302 2.156.88a.667.667 0 1 1-.98.905c-.253-.275-.659-.46-1.165-.452z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })